import map from 'lodash/map';
import {getEndpoint, getHeaders} from '../../../helpers/endpoint';

export const REQUEST_FETCH_STATS_LEAGUES = 'REQUEST_FETCH_STATS_LEAGUES';
export const SUCCESS_FETCH_STATS_LEAGUES = 'SUCCESS_FETCH_STATS_LEAGUES';
export const FAIL_FETCH_STATS_LEAGUES = 'FAIL_FETCH_STATS_LEAGUES';

export const fetchStatsLeagues = (payload, onSuccess, onFail, onRequest) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_STATS_LEAGUES, payload});
    if (onRequest) onRequest(payload);

    fetch(getEndpoint('fetchStatsLeagues', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_FETCH_STATS_LEAGUES});
        else {
          const leagues = data.leaguesCreationsBreakdown.creations;
          const creations = map({...leagues}, (stat, key) => {
            return {...stat, id: `creations-${key}`, date: key};
          });

          dispatch({
            type: SUCCESS_FETCH_STATS_LEAGUES,
            data: {...data.leaguesCreationsBreakdown.countries, creations},
          });
        }

        if (onSuccess) onSuccess(data, payload);
      })
      .catch((error, type = FAIL_FETCH_STATS_LEAGUES) => {
        if (onFail) onFail(type, error);
        dispatch({type, error});
      });
  };
};

export const REQUEST_FETCH_STATS_LEAGUES_BY_STATUS =
  'REQUEST_FETCH_STATS_LEAGUES_BY_STATUS';
export const SUCCESS_FETCH_STATS_LEAGUES_BY_STATUS =
  'SUCCESS_FETCH_STATS_LEAGUES_BY_STATUS';
export const FAIL_FETCH_STATS_LEAGUES_BY_STATUS =
  'FAIL_FETCH_STATS_LEAGUES_BY_STATUS';

export const fetchStatsLeaguesByStatus = (
  payload,
  onSuccess,
  onFail,
  onRequest,
) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_STATS_LEAGUES_BY_STATUS, payload});
    if (onRequest) onRequest(payload);

    fetch(getEndpoint('fetchStatsLeaguesByStatus', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_FETCH_STATS_LEAGUES_BY_STATUS});
        else
          dispatch({
            type: SUCCESS_FETCH_STATS_LEAGUES_BY_STATUS,
            data: data.leaguesStatusesBreakdown.countries,
          });

        if (onSuccess) onSuccess(data, payload);
      })
      .catch((error, type = FAIL_FETCH_STATS_LEAGUES_BY_STATUS) => {
        if (onFail) onFail(type, error);
        dispatch({type, error});
      });
  };
};

export const REQUEST_FETCH_STATS_LEAGUES_RESTART =
  'REQUEST_FETCH_STATS_LEAGUES_RESTART';
export const SUCCESS_FETCH_STATS_LEAGUES_RESTART =
  'SUCCESS_FETCH_STATS_LEAGUES_RESTART';
export const FAIL_FETCH_STATS_LEAGUES_RESTART =
  'FAIL_FETCH_STATS_LEAGUES_RESTART';

export const fetchStatsLeaguesRestart = (
  payload,
  onSuccess,
  onFail,
  onRequest,
) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_STATS_LEAGUES_RESTART, payload});
    if (onRequest) onRequest(payload);

    fetch(getEndpoint('fetchStatsLeaguesRestart', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_FETCH_STATS_LEAGUES_RESTART});
        else
          dispatch({
            type: SUCCESS_FETCH_STATS_LEAGUES_RESTART,
            data: data.leaguesRestartsBreakdown.countries,
          });

        if (onSuccess) onSuccess(data, payload);
      })
      .catch((error, type = FAIL_FETCH_STATS_LEAGUES_RESTART) => {
        if (onFail) onFail(type, error);
        dispatch({type, error});
      });
  };
};

export const REQUEST_FETCH_STATS_LEAGUES_REACTIVATED =
  'REQUEST_FETCH_STATS_LEAGUES_REACTIVATED';
export const SUCCESS_FETCH_STATS_LEAGUES_REACTIVATED =
  'SUCCESS_FETCH_STATS_LEAGUES_REACTIVATED';
export const FAIL_FETCH_STATS_LEAGUES_REACTIVATED =
  'FAIL_FETCH_STATS_LEAGUES_REACTIVATED';

export const fetchStatsLeaguesReactivated = (
  payload,
  onSuccess,
  onFail,
  onRequest,
) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_STATS_LEAGUES_REACTIVATED, payload});
    if (onRequest) onRequest(payload);

    fetch(getEndpoint('fetchStatsLeaguesReactivated', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_FETCH_STATS_LEAGUES_REACTIVATED});
        else dispatch({type: SUCCESS_FETCH_STATS_LEAGUES_REACTIVATED, data});

        if (onSuccess) onSuccess(data, payload);
      })
      .catch((error, type = FAIL_FETCH_STATS_LEAGUES_REACTIVATED) => {
        if (onFail) onFail(type, error);
        dispatch({type, error});
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/entities/statistics/leagues.js